/**
 * backButton.js
 *
 * Makes Android's back gesture and back button walk the app's own history.
 *
 * Capacitor's BridgeActivity has no back handling of its own, so without a
 * listener the system back swipe closed the app from any page. Once a
 * backButton listener exists Capacitor stops doing anything by default, so
 * the root case has to exit explicitly or back would do nothing at all.
 *
 * iOS gets the edge swipe natively (MainViewController.swift) and fires no
 * backButton event, so this only matters on Android.
 */
import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';

export function registerBackButton() {
  if (Capacitor.getPlatform() !== 'android') return;
  App.addListener('backButton', ({ canGoBack }) => {
    if (canGoBack) window.history.back();
    else App.exitApp();
  }).catch(() => {
    // Plugin unavailable; the system default (close the app) still applies.
  });
}
